import React, { useState } from "react";
import { useListAllQuery, useReorderMutation } from "../../../api/banners.api";
import LoadingComponent from "../../../common/Loading/Loading.component";
import AdminTitle from "../../../common/AdminTitle/AdminTitle";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const SortableBanner = ({ banner }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: banner._id }); // use _id or unique identifier

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: "10px",
    margin: "10px 0",
    border: "1px solid #ccc",
    borderRadius: "8px",
    background: "#fafafa",
    cursor: "grab",
    display:"flex",
    gap:"20px"
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div>
        {banner.category === "image" && (
          <img src={banner.desktopImage} alt="" width="200" />
        )}
        {banner.category === "video" && (
          <video src={banner.desktopVideo} width="200" controls />
        )}
      </div>
      <div className="reorder_banner_title">{banner.title}</div>
    </div>
  );
};

const BannersReorder = () => {
  const { data, error, isLoading } = useListAllQuery();
  const bannersList = data?.result || [];
  const [reOrder] = useReorderMutation()
  const navigate = useNavigate()

  const [items, setItems] = useState(bannersList);

  const reorderBanner = async () => {
    try {
      const orderedIds = items.map((b) => b._id); // just array of IDs
      await reOrder(orderedIds).unwrap();
      toast.success("Banner updated sucessfully")
      navigate('/dashboard/banners')
    } catch (err) {
      toast.error("Failed to update banner")
    }
  };

  // Update state whenever API fetches data
  React.useEffect(() => {
    if (bannersList && bannersList.length > 0) {
      const activeBanners = bannersList.filter(banner => banner.status === 'active');
      setItems(activeBanners);
    }
  }, [bannersList]);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      setItems((prev) => {
        const oldIndex = prev.findIndex((b) => b._id === active.id);
        const newIndex = prev.findIndex((b) => b._id === over.id);
        return arrayMove(prev, oldIndex, newIndex);
      });
    }
  };

  return (
    <div className="admin_margin_box">
      <div className="admin_titles">
        <AdminTitle label1="Banner List" url="/dashboard/banners" />
        <div className="Dashboard_title">
          <h1>Banner Re-order (Drag and drop the banner.)</h1>
        </div>
      </div>

      <div className="blog_table">
        {isLoading ? (
          <LoadingComponent />
        ) : error ? (
          <p>Error loading banners</p>
        ) : items.length > 0 ? (
          <DndContext
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={items.map((b) => b._id)}
              strategy={verticalListSortingStrategy}
            >
              {items.map((banner) => (
                <SortableBanner key={banner._id} banner={banner} />
              ))}
            </SortableContext>
          </DndContext>
        ) : (
          <p>Banner List is Empty</p>
        )}
      </div>

      {/* Save button to send reordered banners to backend */}
      <button className='edit_btn' onClick={reorderBanner} >
        Save Order
      </button>
    </div>
  );
};

export default BannersReorder;
